import { CoreIcon } from '../core-icon';
import ticketSVG from '../../assets/icons/ticket.svg';
import type { IconProps } from '../core-icon';

export const TicketIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={ticketSVG} {...props} />;
};
